var map = {
	"./en/BackendNaming.json": [
		41725,
		725
	],
	"./en/BirdsTranslation.json": [
		49132,
		132
	],
	"./en/CleanSurfaceTranslation.json": [
		9114,
		114
	],
	"./en/DashboardTranslation.json": [
		47008,
		8
	],
	"./en/DishwasherTranslation.json": [
		3270,
		270
	],
	"./en/FoodTranslation.json": [
		29058,
		58
	],
	"./en/FrequentlyAskedQuestions.json": [
		88199,
		199
	],
	"./en/FruitsTranslation.json": [
		99135,
		135
	],
	"./en/GonogoTranslation.json": [
		11539,
		539
	],
	"./en/ItemsTranslation.json": [
		85048,
		48
	],
	"./en/Landing.json": [
		68922,
		922
	],
	"./en/MultiobjectTranslation.json": [
		41866,
		866
	],
	"./en/Pricing.json": [
		4379,
		379
	],
	"./en/Tutorials.json": [
		14141,
		522
	],
	"./en/Voices.json": [
		55528,
		528
	],
	"./es/BackendNaming.json": [
		91330,
		330
	],
	"./es/BirdsTranslation.json": [
		93809,
		809
	],
	"./es/CleanSurfaceTranslation.json": [
		63953,
		953
	],
	"./es/CoffeeTranslation.json": [
		61757,
		757
	],
	"./es/DashboardTranslation.json": [
		93177
	],
	"./es/DishwasherTranslation.json": [
		41049,
		49
	],
	"./es/FoodTranslation.json": [
		62617,
		617
	],
	"./es/FrequentlyAskedQuestions.json": [
		52474,
		474
	],
	"./es/FruitsTranslation.json": [
		82168,
		168
	],
	"./es/GonogoTranslation.json": [
		18548,
		548
	],
	"./es/ItemsTranslation.json": [
		29685,
		685
	],
	"./es/Landing.json": [
		84433
	],
	"./es/MultiobjectTranslation.json": [
		10059,
		59
	],
	"./es/Pricing.json": [
		9292
	],
	"./es/Tutorials.json": [
		57801,
		801
	],
	"./es/Voices.json": [
		9025,
		25
	],
	"./it/BackendNaming.json": [
		12231,
		231
	],
	"./it/BirdsTranslation.json": [
		30286,
		286
	],
	"./it/CleanSurfaceTranslation.json": [
		9284,
		284
	],
	"./it/DashboardTranslation.json": [
		84710,
		710
	],
	"./it/DishwasherTranslation.json": [
		57984,
		984
	],
	"./it/FoodTranslation.json": [
		99584,
		584
	],
	"./it/FrequentlyAskedQuestions.json": [
		24541,
		541
	],
	"./it/FruitsTranslation.json": [
		38109,
		109
	],
	"./it/GonogoTranslation.json": [
		93341,
		341
	],
	"./it/ItemsTranslation.json": [
		86378,
		378
	],
	"./it/Landing.json": [
		97732,
		732
	],
	"./it/MultiobjectTranslation.json": [
		99648,
		648
	],
	"./it/Pricing.json": [
		5505,
		505
	],
	"./it/Tutorials.json": [
		92812,
		812
	],
	"./it/Voices.json": [
		5074,
		74
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11227;
module.exports = webpackAsyncContext;